import styled from "@emotion/styled"
import { readableColor } from "polished"
import BackgroundImage from "gatsby-background-image"

import { rhythm } from "@utils/typography"

const Panel = styled.div`
  background: ${props =>
    props.background ? props.background : props.theme.backgroundColor};
  color: ${props =>
    props.background ? readableColor(props.background) : props.theme.color};
  padding: ${props => props.padding ? rhythm(props.padding) : rhythm(2)} 0;
  ${props => props.spaced && `margin: ${rhythm(2)} 0;`}
`

const SpacedTop = styled(Panel)`
  margin-top: ${rhythm(3)};
  .gatsby-image-wrapper {
    float: left;
    margin: ${rhythm(-3)} ${rhythm(1)} ${rhythm(1 / 2)} 0;
  }
`

const ImageWrapper = styled(BackgroundImage)`
  background-position: ${props => props.position || "center"};
  margin: ${rhythm(2)} 0;
  padding: ${rhythm(2)};
  ${props => props.theme.mq[2]} {
    padding: ${rhythm(20)} 0 ${rhythm(2)} 0;
  }
`

export { Panel, ImageWrapper, SpacedTop }
